import { useState, useEffect, useCallback } from "react";
import { fetchWithAuth } from "../utils/fetchWithAuth";
import { useLang } from "../context/LangContext";

export const useSubscriptionInfo = () => {
  const [accountType, setAccountType] = useState(null);
  const [renewalDate, setRenewalDate] = useState(null);
  const [cancellationDate, setCancellationDate] = useState(null);
  const [licenses, setLicenses] = useState([]);
  const [numberOfLicenses, setNumberOfLicenses] = useState([]);
  const [subscriptionToken, setSubscriptionToken] = useState(null);
  const [invoices, setInvoices] = useState(null);
  const { lang } = useLang();

  const formatDate = useCallback(
    (dateString) => {
      if (dateString === null) return "";
      const options = { year: "numeric", month: "long", day: "numeric" };
      const date = new Date(dateString);
      return date.toLocaleDateString(lang, options);
    },
    [lang],
  );

  const fetchSubscriptionInfo = useCallback(async () => {
    try {
      const response = await fetchWithAuth(`/subscriptions/subscription-info`, {
        method: "GET",
      });
      const data = await response.json();

      if (data.error) {
        console.error("Erreur:", data.error);
      } else {
        setAccountType(data.plan);
        setRenewalDate(
          data.nextRenewalDate ? formatDate(data.nextRenewalDate) : "-",
        );
        setCancellationDate(
          data.cancellationDate ? formatDate(data.cancellationDate) : null,
        );
        setLicenses(data.licenses || []);
        setNumberOfLicenses(data.numberOfLicenses);
        setSubscriptionToken(data.subscriptionToken);
        setInvoices(data.invoices || []);
        console.log("Invoices:", data.invoices);
      }
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des informations d'abonnement:",
        error,
      );
    }
  }, [formatDate]);

  useEffect(() => {
    fetchSubscriptionInfo();
  }, [fetchSubscriptionInfo]);

  return {
    accountType,
    renewalDate,
    cancellationDate,
    licenses,
    numberOfLicenses,
    invoices,
    subscriptionToken,
    fetchSubscriptionInfo,
  };
};
